export default "__VITE_ASSET__BZnORP0Q__"